import { hasOwnProperty, isDefined } from "../../infra3d";
import { Obj } from "../internal";
export var PROJECTION;
(function (PROJECTION) {
    PROJECTION[PROJECTION["PERSPECTIVE"] = 0] = "PERSPECTIVE";
    PROJECTION[PROJECTION["PANORAMIC"] = 1] = "PANORAMIC";
})(PROJECTION || (PROJECTION = {}));
export var STREAMTYPE;
(function (STREAMTYPE) {
    STREAMTYPE[STREAMTYPE["MONO"] = 0] = "MONO";
    STREAMTYPE[STREAMTYPE["STEREO"] = 1] = "STEREO";
    STREAMTYPE[STREAMTYPE["CUBEMAP"] = 2] = "CUBEMAP";
    STREAMTYPE[STREAMTYPE["CALOTTE"] = 3] = "CALOTTE";
})(STREAMTYPE || (STREAMTYPE = {}));
export class ImageMeta extends Obj {
    constructor() {
        super(...arguments);
        this.format = "";
        this.height = -1;
        this.idimagemeta = -1;
        this.maxzoom = -1;
        this.minzoom = -1;
        this.pixsize = -1; //microns
        this.structure = "";
        this.tilesize = -1;
        this.width = -1;
        this.focallength = 0; //millimeters
    }
}
export class DepthmapMeta extends Obj {
    constructor() {
        super(...arguments);
        this.format = "";
        this.height = -1;
        this.maxzoom = -1;
        this.minzoom = -1;
        this.pixsize = -1;
        this.structure = "";
        this.tilesize = -1;
        this.width = -1;
        this.numdisparities = -1;
        this.focallength = 0; //millimeters
        this.basis = 0; //meters
    }
}
/**
 * MeasureInfo
 * @class MeasureInfo
 * @extends {Obj}
 */
export class MeasureInfo extends Obj {
    constructor(minfo, streaminfo) {
        super();
        this.streamtype = STREAMTYPE.MONO;
        if (minfo !== null && isDefined(minfo)) {
            for (const property in minfo) {
                this[property] = minfo[property];
            }
        }
        if (streaminfo !== null && isDefined(streaminfo)) {
            let im = null;
            this.projection = MeasureInfo.projectionToNumber(streaminfo.sensorarray.projection.toLowerCase());
            if (hasOwnProperty(streaminfo, "imagemeta")) {
                this.imagemeta = new ImageMeta();
                im = streaminfo["imagemeta"];
                for (const property in im) {
                    if (hasOwnProperty(this.imagemeta, property)) {
                        this.imagemeta[property] = im[property];
                    }
                }
                this.imagemeta.pixsize = im["pixelsize"];
            }
            if (hasOwnProperty(streaminfo, "depthmapmeta")) {
                this.depthmapmeta = new DepthmapMeta();
                const dm = streaminfo["depthmapmeta"];
                for (const property in dm) {
                    if (hasOwnProperty(this.depthmapmeta, property)) {
                        this.depthmapmeta[property] = dm[property];
                    }
                }
                this.depthmapmeta.pixsize = dm["pixelsize"];
                if (!hasOwnProperty(dm, "tilesize")) {
                    if (hasOwnProperty(im, "tilesize")) {
                        this.depthmapmeta.tilesize = this.imagemeta.tilesize;
                    }
                }
                if (this.depthmapmeta["structure"] == "none")
                    this.depthmapmeta["maxzoom"] = -1;
            }
            this.height = streaminfo.sensorarray.height;
            this.name = streaminfo.sensorarray.name;
            // this.normck = streaminfo.sensorarray.focallength;
            // if (this.projection == PROJECTION.PERSPECTIVE) {
            //     this.normbasis = streaminfo.sensorarray.basis;
            // } else {
            //     this.normbasis = 1.0;
            // }
            //this.normbasis = streaminfo.sensorarray.basis == 0.0 ? 1.0 : streaminfo.sensorarray.basis;
            this.orientation = streaminfo.sensorarray.orientation;
            this.sensorgroup = streaminfo.sensorarray.sensorgroup;
            this.tilt = streaminfo.sensorarray.tilt;
            this.tooltip = streaminfo.sensorarray.tooltip;
            this.sensors = streaminfo.sensorarray.sensors;
            this.precFocallength = streaminfo.sensorarray.precFocallength;
            this.precBasis = streaminfo.sensorarray.precBasis;
            this.precDisparity = streaminfo.sensorarray.precDisparity;
            this.streamtype = MeasureInfo.streamtypeToNumber(streaminfo.type);
        }
    }
    static projectionToString(type) {
        switch (type) {
            case PROJECTION.PERSPECTIVE:
                return "perspective";
            case PROJECTION.PANORAMIC:
                return "panoramic";
        }
        return "";
    }
    static projectionToNumber(type) {
        if (typeof type == "number")
            return type;
        switch (type) {
            case "perspective":
            case "none":
            case "":
                return PROJECTION.PERSPECTIVE;
            case "panoramic":
            case "equidistant":
                return PROJECTION.PANORAMIC;
        }
        return -1;
    }
    static streamtypeToString(type) {
        switch (type) {
            case STREAMTYPE.MONO:
                return "mono";
            case STREAMTYPE.STEREO:
                return "stereo";
            case STREAMTYPE.CUBEMAP:
                return "cubemap";
            case STREAMTYPE.CALOTTE:
                return "calotte";
        }
        return "";
    }
    static streamtypeToNumber(type) {
        if (typeof type == "number")
            return type;
        switch (type) {
            case "mono":
                return STREAMTYPE.MONO;
            case "stereo":
                return STREAMTYPE.STEREO;
            case "cubemap":
                return STREAMTYPE.CUBEMAP;
            case "calotte":
                return STREAMTYPE.CALOTTE;
        }
        return STREAMTYPE.MONO;
    }
}
//# sourceMappingURL=measureinfo.js.map